import React from "react";
import PropTypes from "prop-types";
import Immutable, {
    List,
    OrderedMap,
} from "immutable";
import { Row, Col, Card, Statistic, Button } from "antd";
import MpaCreateForm from "../../forms/mpa-create-form";
import CompanyService from "../../services/company-los-services";
import { CompanyService as CompanyLosService } from "services/index";
import { Table } from "components";
import { DB_DEVIATIONS_COLUMNS } from "constants/table-columns";
import AddDeviationModal from "./add-deviation-modal";


const getProfileLayout = (data, constitution = "Not Raised") => new OrderedMap({
    gstin: {
        span: 6,
        key: "gstin",
        label: "GSTIN",
        value: data.gstin,
        type: "CARD"
    },
    type: {
        span: 6,
        key: "type",
        label: "Type",
        value: data.companyType,
        type: "card"
    },
    primary_relationship_manager: {
        span: 6,
        key: "primary_relationship_manager",
        label: "Primary RM",
        value: data.primary_relationship_manager && data.primary_relationship_manager.full_name,
        type: "card"
    },
    request_status: {
        span: 6,
        key: "request_status",
        label: "Request Status",
        value: constitution,
        type: "card"
    },
});



class DBMpaRequest extends React.Component {

    state = {
        salesManagers: [],
        gstin_address_fetch: false,
        gstin_address: null,
        mpaApiData: null,
        loading: true,
        deviationModalVisible: false,
        dbDeviationList: [],
        deviationListLoader: false
    };

    formRef = React.createRef();
    componentDidMount() {
        // this.getMpaRequest();
       this.fetchDbDeviations();
    }

    fetchDbDeviations = () => {
        this.setState({
            deviationListLoader: true
        })
        CompanyLosService.getDeviationsList([this.props.companyId])
            .then(({ data }) => {
                this.setState({
                    dbDeviationList: data,
                    deviationListLoader: false

                })
            })
            .catch((err) => {
                this.setState({
                    dbDeviationList: [],
                    deviationListLoader: false

                })
            })
    }

    getMpaRequest = () => {
        CompanyLosService.getMpaDataApi(this.props.companyId).then(res => {
            this.setState({ mpaApiData: res.data, loading: false });
        }).catch((err) => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    fetchChannelProducts = search => {
        return CompanyService.getChannelProducts(search);
    }
    fetchVpSalesManagers = async search => {
        return CompanyService.getVPSMList(search);
    }
    fetchIndustryTypes = async search => {
        return CompanyService.industryTypeList(search);
    }
    loadingFn = (val) => {
        this.setState({ loading: val });
    }

    handleDeviationModal = () => {
        this.setState({
            deviationModalVisible: !this.state.deviationModalVisible
        })
    }
    render() {
        const { deviationModalVisible } = this.state;
        return <Row>
            <AddDeviationModal
                visible={deviationModalVisible}
                closeModal={this.handleDeviationModal}
                companyId={this.props.companyId}
                companyName={this.props.profile && this.props.profile.getIn(["data", "name"])}
                fetchDbDeviations={this.fetchDbDeviations}
                all_enums={this.props.all_enums}
            />
            {/* <Row>
                <Col span={18} offset={3} className={"pb-5"}>
                    <Row gutter={24}>
                        {
                            getProfileLayout(this.props.profile.get("data"), this.state.mpaApiData?.current_status).map(_ =>
                            (
                                <Col key={_.key} span={_.span}>
                                    <Card title={null} className={"border-none"} size={"default"} >
                                        <Statistic
                                            valueStyle={{
                                                fontSize: "16px",
                                                fontWeight: 500
                                            }}
                                            title={_.label}
                                            value={_.value || "--"}
                                        />
                                    </Card>
                                </Col>
                            )
                            ).toList()
                        }
                    </Row>
                </Col>
            </Row> */}
            <Row>
            <Col span={18} offset={3} className={"pb-5 mt-10"}>
                <Col span="12">
                    <h3>DB Level Deviations</h3>
                </Col>
                <Col span="12" className="text-right">
                    <Button icon={"plus"} type={"primary"} onClick={this.handleDeviationModal}>Add Deviation</Button>
                </Col>
                </Col>
            </Row>
            {/* <Col span={18} offset={3}>
                <MpaCreateForm
                    mpaData={Immutable.fromJS(this.state.mpaApiData)}
                    getMpaRequest = {this.getMpaRequest}
                    gstinValidator={this.gstinValidation}
                    fetchChannelProducts={this.fetchChannelProducts}
                    loading={this.state.loading}
                    loadingFn= {this.loadingFn}
                    salesPermission={this.props.permissions.get("can_mpa_initiate")}
                    creditPermission={this.props.permissions.get("can_mpa_approve")}
                    fetchIndustryTypes={this.fetchIndustryTypes}
                    fetchVpSalesManagers={this.fetchVpSalesManagers}
                    companyId={this.props.companyId}
                    profile = {this.props.profile}
                />
            </Col> */}
            <Row>
                <Col offset={3} span={18} className={"pb-5"}>
                    <Table
                        loading={this.state.deviationListLoader}
                        showHeader={false}
                        showFooter={false}
                        pagination={false}
                        showTopSection={false}
                        noRowSelection
                        columns={DB_DEVIATIONS_COLUMNS(this.props.all_enums.getIn(['data' , "deviation_types"]), this.props.all_enums.getIn(["data","underlying_commitment_type"]) )}
                        data={this.state.dbDeviationList && this.state.dbDeviationList.length && List(this.state.dbDeviationList.map(_ => {
                            let row = _;
                            row.action = ([
                               <Button type={"link"} size={"small"} href={_.file}> Download</Button> 
                            ]);
                            return row;
                        })) || List()}
                    />
                </Col>
            </Row>


        </Row>;
    }
}


DBMpaRequest.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    companyId: PropTypes.string,
    profile: PropTypes.object,
    permissions: PropTypes.object,
    detail: PropTypes.object,
    updateCompanyLosDetail: PropTypes.func,
    user: PropTypes.object,
};

export default DBMpaRequest;